import React from "react";
import { Outlet } from "react-router-dom";
import { Header } from "./sub-component/Header";
import { Footer } from "./sub-component/Footer";

export const Layout: React.FC = () => {
    return (
        <>
            <Header />
            <div style={{ marginTop: "101px", marginBottom: "20px" }}>
                <Outlet />
            </div>
            <Footer />
        </>
    )
};